// src/pages/ContactUs/index.js
import React, { useEffect, useState } from "react";
import { Container, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import CommonDataTable from "../../common/DataTable";
import { getContactColumns } from "../../Components/Common/columns/Contacts";
import { fetchAllContacts, fetchContactById } from "../../slices/contectUs/thunk";

const ContactUs = () => {
    const dispatch = useDispatch();

    const [filterParams, setFilterParams] = useState({
        page: 1,
        currentPage: 1,
        limit: 10,
        perPage: 10,
        search: "",
        orderBy: "createdAt",
        order: "desc",
    });

    const [viewModalOpen, setViewModalOpen] = useState(false);
    const [selectedContact, setSelectedContact] = useState(null);

    const { contacts, totalRows, loading, contactDetails, currentPage, pageSize } = useSelector((state) => state.Contact || {});

    // ✅ FIXED: Removed the useEffect that was syncing filterParams with Redux state
    // This was causing conflicts with pagination updates

    const fetchData = async (params = {}) => {
        console.log("fetchData called with params:", params); // Debug log
        
        // ✅ FIXED: Simplified parameter mapping
        const limit = params.perPage || params.limit || filterParams.limit || 10;
        const page = params.page || params.currentPage || filterParams.page || 1;
        
        const updatedParams = {
            page: page,
            currentPage: page,
            limit: limit,
            perPage: limit,
            search: params.search !== undefined ? params.search : filterParams.search,
            orderBy: params.orderBy || filterParams.orderBy || "createdAt",
            order: params.order || filterParams.order || "desc",
        };
        
        console.log("Updated params being sent to API:", updatedParams); // Debug log
        
        setFilterParams(updatedParams);
        dispatch(fetchAllContacts(updatedParams));
    };

    useEffect(() => {
        fetchData();
    }, []); // Only run on mount

    // Load contact details when modal opens
    useEffect(() => {
        if (viewModalOpen && selectedContact?._id) {
            dispatch(fetchContactById(selectedContact._id));
        }
    }, [viewModalOpen, selectedContact, dispatch]);

    // ✅ FIXED: Row click handler for opening modal
    const handleRowClick = (row) => {
        console.log("Row clicked:", row); // Debug log
        setSelectedContact(row);
        setViewModalOpen(true);
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        } catch (error) {
            return dateString;
        }
    };

    // ✅ FIXED: Pass handleRowClick to getContactColumns if needed in the future
    const columns = getContactColumns();

    // Use contactDetails if available, otherwise use selectedContact
    const displayContact = contactDetails || selectedContact;

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Contacts" pageTitle="Contacts" />
                <CommonDataTable
                    columns={columns}
                    data={contacts || []}
                    totalRows={totalRows || 0}
                    loading={loading}
                    fetchData={fetchData}
                    filterParams={filterParams}
                    searchEnable
                    checkboxEnabled={true}
                    showExportButton
                    showAddButton={false}
                    exportFileName="contacts"
                    onRowClick={handleRowClick}
                />

                {/* View Contact Modal */}
                <Modal isOpen={viewModalOpen} toggle={() => setViewModalOpen(false)} size="lg" className="modal-fixed-header-footer">
                    <ModalHeader toggle={() => setViewModalOpen(false)}>
                        Contact Details
                    </ModalHeader>
                    <ModalBody>
                        {displayContact ? (
                            <div className="contact-details">
                                <div className="mb-3">
                                    <h6 className="text-muted mb-1">Full Name</h6>
                                    <p className="mb-0">{displayContact.fullName || "-"}</p>
                                </div>
                                <div className="mb-3">
                                    <h6 className="text-muted mb-1">Email</h6>
                                    <p className="mb-0">
                                        <a href={`mailto:${displayContact.email}`}>
                                            {displayContact.email || "-"}
                                        </a>
                                    </p>
                                </div>
                                <div className="mb-3">
                                    <h6 className="text-muted mb-1">Phone Number</h6>
                                    <p className="mb-0">
                                        {displayContact.phoneNumber ? (
                                            <a href={`tel:${displayContact.phoneNumber}`}>
                                                {displayContact.phoneNumber}
                                            </a>
                                        ) : "-"}
                                    </p>
                                </div>
                                <div className="mb-3">
                                    <h6 className="text-muted mb-1">Message</h6>
                                    <p className="mb-0" style={{ whiteSpace: "pre-wrap" }}>
                                        {displayContact.message || "-"}
                                    </p>
                                </div>
                                <div className="mb-3">
                                    <h6 className="text-muted mb-1">Submitted At</h6>
                                    <p className="mb-0">
                                        {formatDate(displayContact.createdAt || displayContact.created_at)}
                                    </p>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center py-4">
                                <p>Loading contact details...</p>
                            </div>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={() => setViewModalOpen(false)}>
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            </Container>
        </div>
    );
};

export default ContactUs;